"use client";

import { useEffect, useRef, useState } from "react";
import { loadedTrainers } from "./LoadedTrainers";
import { useTrainerContext } from "@/context/TrainerContext";
import InfiniteScroll from "@/components/InfiniteScroll";
import TrainerCard, {
  TrainerLoading,
} from "@/components/views/worker/TrainerCard";
import AddProfileCard from "@/components/views/worker/AddProfileCard";
import { DEFAULT_DATA_LIMIT } from "@/@core/constants/pagination";

export default function LoadingTrainers({ initialData }: { initialData: any[] }) {
  const [trainers, setTrainers] = useState<any[]>(initialData);
  const [hasMore, setHasMore] = useState(initialData?.length >= DEFAULT_DATA_LIMIT);
  const { trainerFilters } = useTrainerContext();
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setIsLoading(true);
    loadedTrainers({ ...trainerFilters, page: 0 }).then((data) => {
      setIsLoading(false);
      setTrainers(data);

      const moreBlogsAvailable = data.length === 0 || data.length < DEFAULT_DATA_LIMIT;
      setHasMore(!moreBlogsAvailable)
    });
  }, [trainerFilters]);

  useEffect(() => {
    if (isLoading) return;
    if (page == 0) return;

    setIsLoading(true);
    loadedTrainers({ ...trainerFilters, page: page }).then((response) => {
      setIsLoading(false);
      setTrainers([...trainers, ...response]);

      if (response.length < DEFAULT_DATA_LIMIT || response.length === 0)
        setHasMore(false);
    });
  }, [page]);

  return (
    <>
      <div className="py-4">
        <InfiniteScroll
          dataLength={trainers.length || 0}
          isLoading={isLoading}
          skeletonElementId="trainer-card-skeleton"
          hasMore={hasMore}
          loading={
            <div className="py-4">
              <TrainerLoading count={6} />
            </div>
          }
          next={() => setPage(page + 1)}
        >
          <div className="grid justify-items-center grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {Array.isArray(trainers) &&
              trainers?.map((trainer) => {
                return <TrainerCard key={trainer.id} {...trainer} />;
              })}

            <AddProfileCard />
          </div>
        </InfiniteScroll>
      </div>
    </>
  );
}
